import { GetEvent } from './GetEvent';
import { GetEventData, GetEventQueryPayload } from './GetEvent/includes/types';
import { ListEvents } from './ListEvents';
import { ListEventsData, ListEventsQueryPayload } from './ListEvents/includes/types';
import { ListEventTypes } from './ListEventTypes';
import { ListEventTypesData, ListEventTypesQueryPayload } from './ListEventTypes/includes/types';

export type Queries = {
  GetEvent: (payload: GetEventQueryPayload) => Promise<GetEventData>;
  ListEvents: (payload: ListEventsQueryPayload) => Promise<ListEventsData>;
  ListEventTypes: (payload: ListEventTypesQueryPayload) => Promise<ListEventTypesData>;
};

export const queries: Queries = {
  GetEvent,
  ListEvents,
  ListEventTypes,
};
